export const CALCULATION_MODEL_INNER_NODE_KINDS = [
  'filter',
  'conversion',
  'multiplier',
] as const;

export type CalculationModelInnerNodeKind =
  (typeof CALCULATION_MODEL_INNER_NODE_KINDS)[number];

export const CALCULATION_MODEL_PROCESS_NODE_KINDS = [
  'impact',
  ...CALCULATION_MODEL_INNER_NODE_KINDS,
] as const;

export type CalculationModelProcessNodeKind =
  (typeof CALCULATION_MODEL_PROCESS_NODE_KINDS)[number];

export const CALCULATION_MODEL_NODE_KINDS = [
  ...CALCULATION_MODEL_PROCESS_NODE_KINDS,
  'import',
] as const;

export type CalculationModelNodeKind =
  (typeof CALCULATION_MODEL_NODE_KINDS)[number];
